import { useSubscriptionContext } from '@/context/SubscriptionContext';

import { useIsPremiumFeatureEnabled } from './useIsPremiumFeatureEnabled';

export const useIsPremiumFeatureAvailable = () => {
    const { isPremiumFeatureEnabled } = useIsPremiumFeatureEnabled();
    const { isCurrentSubscriptionActive } = useSubscriptionContext();

    return {
        isPremiumFeatureAvailable:
            !isPremiumFeatureEnabled || isCurrentSubscriptionActive,
    };
};
